// extracted by mini-css-extract-plugin
module.exports = {"textlink":"malt-textlink-index-textlink-7c8430a9"};